import { render, staticRenderFns } from "./delete-datafile-modal.vue?vue&type=template&id=5700c2a3"
import script from "./delete-datafile-modal.vue?vue&type=script&lang=js"
export * from "./delete-datafile-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports